export const HEADER_HIDE_SEARCH_FORM_COOKIE_KEY = 'hideSearchFormTip';
